import axios from "axios";
import store from "../store";
// 影响请求天气数据
// axios.defaults.withCredentials = true;
// 添加请求拦截器
axios.interceptors.request.use(
  (_config) => {
    const config = _config;
    // let query = window.myVue.$route.query;
    const { token } = store.state.app;
    // const tokenV = store.state.token;
    // let urlToken = query.token;
    // if (token || urlToken) {
    if (token) {
      // config.headers["Authorization"] = "Bearer " + token || urlToken;
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.ProjectId = 9527;
      config.headers["Accept-Language"] = "en";
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  (res) => {
    console.warn(res);
    if (
      res.status === 200 &&
      res.data.error === "Your Session was expired or you need login first!" &&
      window.myVue.$route.path !== "/"
    ) {
      window.myVue.$Message.error({
        content: "请先登录再进行操作",
        duration: 10,
      });
      window.myVue.$router.push("/");
      return false;
    }
    return res;
  },
  (error) => {
    // 2022-07-01-状态码为401或者403就跳回登录页
    if (error.message.includes(401) || error.message.includes(403)) {
      window.myVue.$Message.error({
        content: "Please login again",
        duration: 6,
      });
      setTimeout(() => {
        window.myVue.$router.push("/login");
      }, 3000);
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default axios;
